import { watch as f, shallowRef as m, shallowReadonly as v, onMounted as y, nextTick as h, getCurrentScope as b, onScopeDispose as S, toValue as O, getCurrentInstance as d, hasInjectionContext as j, inject as P } from "vue";
function p(e) {
  return b() ? (S(e), !0) : !1;
}
function I() {
  const e = /* @__PURE__ */ new Set(), t = (r) => {
    e.delete(r);
  };
  return {
    on: (r) => {
      e.add(r);
      const i = () => t(r);
      return p(i), {
        off: i
      };
    },
    off: t,
    trigger: (...r) => Promise.all(Array.from(e).map((i) => i(...r))),
    clear: () => {
      e.clear();
    }
  };
}
const a = /* @__PURE__ */ new WeakMap(), M = (...e) => {
  var t;
  const n = e[0], o = (t = d()) == null ? void 0 : t.proxy;
  if (o == null && !j())
    throw new Error("injectLocal must be called in setup");
  return o && a.has(o) && n in a.get(o) ? a.get(o)[n] : P(...e);
}, w = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const k = Object.prototype.toString, _ = (e) => k.call(e) === "[object Object]", x = () => {
}, F = (e, t) => Object.prototype.hasOwnProperty.call(e, t), W = /* @__PURE__ */ A();
function A() {
  var e, t;
  return w && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window?.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function L(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const o = t;
    t = void 0, o && await o;
  }, n;
}
function D(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function E(e) {
  return Array.isArray(e) ? e : [e];
}
function T(e) {
  return d();
}
function G(e, t = !0, n) {
  T() ? y(e, n) : t ? e() : h(e);
}
function N(e, t, n = {}) {
  const {
    immediate: o = !0,
    immediateCallback: s = !1
  } = n, r = m(!1);
  let i;
  function c() {
    i && (clearTimeout(i), i = void 0);
  }
  function u() {
    r.value = !1, c();
  }
  function l(...g) {
    s && e(), c(), r.value = !0, i = setTimeout(() => {
      r.value = !1, i = void 0, e(...g);
    }, O(t));
  }
  return o && (r.value = !0, w && l()), p(u), {
    isPending: v(r),
    start: l,
    stop: u
  };
}
function R(e, t, n) {
  return f(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
function V(e, t, n) {
  return f(
    e,
    t,
    {
      ...n,
      once: !0
    }
  );
}
export {
  w as a,
  E as b,
  I as c,
  R as d,
  p as e,
  L as f,
  M as g,
  F as h,
  W as i,
  _ as j,
  x as n,
  D as p,
  G as t,
  N as u,
  V as w
};
